module.exports = __webpack_public_path__ + "static/media/mobBellActive.50e143fe.svg";